import { t } from 'i18next';
import { useMutation } from 'react-query';

import { NotificationPosition } from 'core/enums';
import { useHandleErrors } from 'core/hooks';
import { customerOrderService } from 'orders/services';

export const useCustomerOrderActions = () => ({
  ...useCreateFromQuote(),
});

const useCreateFromQuote = () => {
  const { errors } = useHandleErrors({
    error: { title: t('errorTitleOrderCreating') },
    position: NotificationPosition.TOP,
  });

  const { mutateAsync } = useMutation((data) => customerOrderService.createFromQuote(data), {
    ...errors,
  });

  return { createFromQuote: mutateAsync };
};
